var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('A',{staticStyle:{"position":"relative","top":"-105px"},attrs:{"name":_vm.lcName,"id":_vm.lcName}})}
var staticRenderFns = []

export { render, staticRenderFns }